module.exports = __webpack_public_path__ + "static/media/feedback-info.1cf0b521.png";